import React, { useState } from "react";
import { Button } from "./ui/button";

export default function CustomerForm({ onSubmit }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
  });

  function handleSubmit() {
    if (!form.name || !form.phone) {
      alert("Name and phone are required");
      return;
    }
    onSubmit(form);
  }

  return (
    <div className="space-y-4">
      <input
        placeholder="Full Name"
        className="border p-3 rounded w-full"
        onChange={(e) => setForm({ ...form, name: e.target.value })}
      />
      <input
        placeholder="Email"
        className="border p-3 rounded w-full"
        onChange={(e) => setForm({ ...form, email: e.target.value })}
      />
      <input
        placeholder="Phone"
        className="border p-3 rounded w-full"
        onChange={(e) => setForm({ ...form, phone: e.target.value })}
      />
      <input
        placeholder="City"
        className="border p-3 rounded w-full"
        onChange={(e) => setForm({ ...form, city: e.target.value })}
      />

      <Button onClick={handleSubmit} className="w-full">
        Continue to Payment
      </Button>
    </div>
  );
}
